import { useLocation } from "react-router-dom";
import { Box, Container, Typography, Button } from "@mui/material";
import { useState } from "react";

const ThankYouPage = () => {
  const location = useLocation();
  const referralCode = location.state?.referralCode || "";
  const codeUuid = location.state?.codeUuid || "";
  const [copied, setCopied] = useState(false);

  // Use production URL or fall back to current origin
  const baseUrl = "https://yuvachangemakers.com";

  const shareLink = codeUuid ? `${baseUrl}/register/${codeUuid}` : "";

  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#FFF9F0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        py: 4,
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: "16px",
            p: { xs: 3, md: 6 },
            textAlign: "center",
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
          }}
        >
          <img
            src="/assets/popup.jpg"
            alt="Thank You"
            style={{
              maxWidth: "100%",
              height: "auto",
              borderRadius: "8px",
              marginBottom: "32px",
            }}
          />
          <Typography
            sx={{
              fontSize: { xs: "24px", md: "32px" },
              fontFamily: "Elza, sans-serif",
              fontWeight: 600,
              color: "#000",
              lineHeight: 1.5,
              mb: 3,
            }}
          >
            Thank you for registering and becoming a part of Yuva Changemakers!
            We're thrilled to have you on this journey.
          </Typography>

          {referralCode && (
            <>
              <Box
                sx={{
                  backgroundColor: "#FFF9F0",
                  borderRadius: "12px",
                  p: 3,
                  my: 3,
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "18px", md: "20px" },
                    fontFamily: "Elza, sans-serif",
                    fontWeight: 600,
                    color: "#000",
                    mb: 2,
                  }}
                >
                  Here's your unique referral code
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: "32px", md: "42px" },
                    fontFamily: "Elza, sans-serif",
                    fontWeight: 700,
                    color: "#87EA5C",
                    letterSpacing: "4px",
                    mb: 2,
                  }}
                >
                  {referralCode}
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: "14px", md: "16px" },
                    fontFamily: "Elza, sans-serif",
                    color: "#666",
                    lineHeight: 1.6,
                  }}
                >
                  Use this code to invite your friends and fellow changemakers
                  to join the initiative. Together, we can inspire more youth to
                  create change.
                </Typography>
              </Box>

              <Box sx={{ mt: 3 }}>
                <Typography
                  sx={{
                    fontSize: { xs: "16px", md: "18px" },
                    fontFamily: "Elza, sans-serif",
                    fontWeight: 600,
                    color: "#000",
                    mb: 2,
                  }}
                >
                  Share this link and help spread the movement!
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    alignItems: "center",
                    justifyContent: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { xs: "14px", md: "16px" },
                      fontFamily: "Elza, sans-serif",
                      color: "#666",
                      backgroundColor: "#f5f5f5",
                      p: 2,
                      borderRadius: "8px",
                      wordBreak: "break-all",
                      flex: 1,
                      minWidth: "200px",
                    }}
                  >
                    {shareLink}
                  </Typography>
                  <Button
                    variant="contained"
                    onClick={handleCopyLink}
                    sx={{
                      backgroundColor: "#87EA5C",
                      color: "#000",
                      fontFamily: "Elza, sans-serif",
                      fontSize: { xs: "14px", md: "16px" },
                      fontWeight: 600,
                      px: 4,
                      py: 1.5,
                      "&:hover": {
                        backgroundColor: "#75d84a",
                      },
                    }}
                  >
                    {copied ? "Copied!" : "Copy Link"}
                  </Button>
                </Box>
              </Box>
            </>
          )}
        </Box>
      </Container>
    </Box>
  );
};

export default ThankYouPage;
